import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'avmFileSize',
    standalone: true,
})
export class AvmFileSizePipe implements PipeTransform {
    /** Unités de taille de fichier. */
    private units = ['octets', 'KB', 'MB', 'GB', 'TB', 'PB'];

    /**
     * Formate une taille de fichier en octets dans l'unité la plus appropriée.
     * @param bytes : Taille du fichier en octets.
     * @param precision : Nombre de chiffres à afficher après la virgule.
     */
    transform(bytes: number = 0, precision: number = 2): string {
        if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes)) {
            return '?';
        }

        let unit = 0;

        while (bytes >= 1024) {
            bytes /= 1024;
            unit++;
        }

        return bytes.toFixed(+precision) + ' ' + this.units[unit];
    }
}
